var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSensitivity = function SvgSensitivity(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 14,
    viewBox: "0 0 57 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#283333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 1.5,
    r: 1.5,
    fill: "#283333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 1.5,
    r: 1.5,
    fill: "#283333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 1.5,
    r: 1.5,
    fill: "#283333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 1.5,
    r: 1.5,
    fill: "#283333"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 1.5,
    r: 1.5,
    fill: "#283333"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 1.5,
    r: 1.5,
    fill: "#283333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8H57",
    stroke: "#283333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13H57",
    stroke: "#283333"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSensitivity);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCA1NyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMS41IiBjeT0iMS41IiByPSIxLjUiIGZpbGw9IiMyODMzMzMiLz4KPGNpcmNsZSBjeD0iMTkuNSIgY3k9IjEuNSIgcj0iMS41IiBmaWxsPSIjMjgzMzMzIi8+CjxjaXJjbGUgY3g9IjI4LjUiIGN5PSIxLjUiIHI9IjEuNSIgZmlsbD0iIzI4MzMzMyIvPgo8Y2lyY2xlIGN4PSIzNy41IiBjeT0iMS41IiByPSIxLjUiIGZpbGw9IiMyODMzMzMiLz4KPGNpcmNsZSBjeD0iNDYuNSIgY3k9IjEuNSIgcj0iMS41IiBmaWxsPSIjMjgzMzMzIi8+CjxjaXJjbGUgY3g9IjU1LjUiIGN5PSIxLjUiIHI9IjEuNSIgZmlsbD0iIzI4MzMzMyIvPgo8Y2lyY2xlIGN4PSIxMC41IiBjeT0iMS41IiByPSIxLjUiIGZpbGw9IiMyODMzMzMiLz4KPHBhdGggZD0iTTAgOEg1NyIgc3Ryb2tlPSIjMjgzMzMzIi8+CjxwYXRoIGQ9Ik0wIDEzSDU3IiBzdHJva2U9IiMyODMzMzMiLz4KPC9zdmc+Cg==";